import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const arjSettingsLoadingLimitsLegacyRedirectRoute: InvariantJiraRoute = {
	name: 'arj-settings-loading-limits-redirect',
	path: '/secure/PortfolioLoadingLimits.jspa',
};
